import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from './contexts/AuthContext';
import LoginPage from './pages/LoginPage';
import AuthCallbackPage from './pages/AuthCallbackPage';
import DashboardPage from './pages/DashboardPage';
import CompassFormPage from './pages/CompassFormPage';
import CompassListPage from './pages/CompassListPage';
import NotificationsPage from './pages/NotificationsPage';
import SharedCompassesPage from './pages/SharedCompassesPage';
import CompassNotesPage from './pages/CompassNotesPage';
import AccountLinkingPage from './pages/AccountLinkingPage';
import UserSettingsPage from './pages/UserSettingsPage';
import Layout from './components/Layout';

const App: React.FC = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Routes>
      {!isAuthenticated ? (
        <>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </>
      ) : (
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/compass/new" element={<CompassFormPage />} />
          <Route path="/compass/edit/:id" element={<CompassFormPage />} />
          <Route path="/compass/:compassId/notes" element={<CompassNotesPage />} />
          <Route path="/compasses" element={<CompassListPage />} />
          <Route path="/shared" element={<SharedCompassesPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/account-linking" element={<AccountLinkingPage />} />
          <Route path="/settings" element={<UserSettingsPage />} />
          <Route path="/login" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      )}
    </Routes>
  );
};

export default App;
